import { ModuleFE_Advisor_FAQ } from './faq/module.js';
import { ModuleFE_Advisor_FindingView } from './finding-view/module.js';
export const ModulePack_Static_AdvisorUI = [
    ModuleFE_Advisor_FindingView,
    ModuleFE_Advisor_FAQ,
];
//# sourceMappingURL=index.js.map